var _TransformerWeb_instances, _TransformerWeb_pixelsToRem;
import { __classPrivateFieldGet } from "tslib";
import { transformFontWeight } from './agnostic';
import { FONT_FACE_ARIAL, FONT_FACE_CALIBRI } from '../constants';
export default class TransformerWeb {
    constructor() {
        _TransformerWeb_instances.add(this);
    }
    accentColor(accentColor) {
        return accentColor;
    }
    backgroundColor(backgroundColor) {
        return backgroundColor;
    }
    borderBottomLeftRadius(borderRadius) {
        return borderRadius;
    }
    borderBottomRightRadius(borderRadius) {
        return borderRadius;
    }
    borderBottomWidth(borderBottomWidth) {
        return borderBottomWidth;
    }
    borderColor(borderColor) {
        return borderColor;
    }
    borderRadius(borderRadius) {
        return borderRadius;
    }
    borderStyle(borderStyle) {
        return borderStyle;
    }
    borderTopLeftRadius(borderRadius) {
        return borderRadius;
    }
    borderTopRightRadius(borderRadius) {
        return borderRadius;
    }
    borderTopWidth(borderTopWidth) {
        return borderTopWidth;
    }
    borderWidth(borderWidth) {
        return borderWidth;
    }
    boxShadow(boxShadow) {
        return boxShadow;
    }
    color(color) {
        return color;
    }
    fontFamily(fontFamily) {
        if (fontFamily === FONT_FACE_CALIBRI) {
            return `${fontFamily}, ${FONT_FACE_ARIAL}, Helvetica, sans-serif`;
        }
        return `${fontFamily}, Arial, Helvetica, sans-serif`;
    }
    fontSize(fontSize) {
        return __classPrivateFieldGet(this, _TransformerWeb_instances, "m", _TransformerWeb_pixelsToRem).call(this, fontSize);
    }
    fontStyle(fontStyle) {
        return fontStyle;
    }
    fontWeight(fontWeight, fontFamily) {
        return transformFontWeight(fontWeight, fontFamily);
    }
    height(height) {
        return height;
    }
    lineHeight(lineHeight) {
        return lineHeight;
    }
    margin(margin) {
        return margin;
    }
    maxHeight(maxHeight) {
        return maxHeight;
    }
    minHeight(minHeight) {
        return minHeight;
    }
    minWidth(minWidth) {
        return minWidth;
    }
    opacity(opacity) {
        return opacity;
    }
    outlineColor(outlineColor) {
        return outlineColor;
    }
    outlineOffset(outlineOffset) {
        return outlineOffset;
    }
    outlineStyle(outlineStyle) {
        return outlineStyle;
    }
    outlineWidth(outlineWidth) {
        return outlineWidth;
    }
    textAlign(textAlign) {
        return textAlign;
    }
    textDecoration(textDecoration) {
        return textDecoration;
    }
    textDecorationColor(textDecorationColor) {
        return textDecorationColor;
    }
    textDecorationThickness(textDecorationThickness) {
        return textDecorationThickness;
    }
    textUnderlineOffset(textUnderlineOffset) {
        return textUnderlineOffset;
    }
    verticalAlign(verticalAlign) {
        return verticalAlign;
    }
    width(width) {
        return width;
    }
}
_TransformerWeb_instances = new WeakSet(), _TransformerWeb_pixelsToRem = function _TransformerWeb_pixelsToRem(value) {
    if (value.endsWith('rem')) {
        return value;
    }
    if (!value.endsWith('px')) {
        throw new Error('Only pixel values are implemented!');
    }
    if (value.includes('.') || value.includes(',')) {
        throw new Error('Only whole pixels values are implemented!');
    }
    const remWithoutUnit = Number.parseInt(value, 10) / 16;
    return `${remWithoutUnit}rem`;
};
